import React from 'react';
import { BarsIcon } from '@revfluence/fresh-icons/regular/esm'; // Assuming this icon exists
import { Avatar, AvatarFallback, AvatarImage } from '@frontend/shadcn/components/ui/avatar';
import { useAuth } from '@frontend/context/authContext';
import { TProject } from '../../types';

interface Props {
  project: TProject;
}

export const PreviewHeader: React.FC<Props> = ({ project }) => {
  const projectName = project.title;
  const imageUrl = project.splashImageUrl;

  const { clientInfo } = useAuth();

  return (
    <div className="flex items-center gap-2 border-b border-grey-2 p-6 pb-3 bg-white">
      <Avatar className="h-8 w-8 rounded-lg">
        {imageUrl && <AvatarImage src={imageUrl} alt={projectName} />}
        <AvatarFallback className="rounded-lg bg-purple-1 text-purple-4">
          {projectName?.charAt(0).toUpperCase()}
        </AvatarFallback>
      </Avatar>
      <div className="flex-1 flex flex-col">
        <p className="mb-0 text-base font-medium leading-tight text-grey-6">
          {projectName}
        </p>
        <p className="mb-0 text-xs text-grey-5">{clientInfo?.name}</p>
      </div>
      <BarsIcon className="h-4 w-4 text-grey-6" />
    </div>
  );
};
